import { render, staticRenderFns } from "./Media.vue?vue&type=template&id=7d8b633a&scoped=true"
import script from "./Media.vue?vue&type=script&lang=ts"
export * from "./Media.vue?vue&type=script&lang=ts"
import style0 from "./Media.vue?vue&type=style&index=0&id=7d8b633a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8b633a",
  null
  
)

export default component.exports